import { elementUuids } from 'editor/src/util/uuids';

import { DesignData, Spread } from '../types';

import updateDesignPagesUtil from './updateDesignPagesUtil';

function copySpreadUtil(
  designData: DesignData,
  copyFromIndex: number,
  positionAtIndex: number,
  empty: boolean,
  mediaFromIndex?: number,
) {
  let copyMediaFromIndex = copyFromIndex;
  if (mediaFromIndex !== undefined) {
    copyMediaFromIndex = mediaFromIndex;
  }

  const template = designData.spreads[copyFromIndex];
  const newSpread: Spread = JSON.parse(JSON.stringify(template));
  if (empty) {
    newSpread.pages.forEach((page) => {
      page.groups.media = undefined;
    });
  } else {
    // it's possible to have 'blank' + media on photobook front-inner spread.
    // When we duplicate we need to keep both: mediabox from 2 page and media from 1 one
    const newSpreadMedia: Spread =
      copyMediaFromIndex !== copyFromIndex
        ? JSON.parse(JSON.stringify(designData.spreads[copyMediaFromIndex]))
        : newSpread;

    // Regenerate uuids for the media on every page, not just the first one.
    // uuids must be globally unique across the design; leaving later pages with
    // the cloned source uuids makes repeated duplicates collide in the
    // uuid-keyed lookups/render paths and blanks those pages.
    // Page 0's media comes from the media-source spread (the 'blank' + media
    // front-inner spread case); other pages keep their own cloned media.
    newSpread.pages.forEach((page, pageIndex) => {
      const sourceMedia = pageIndex === 0 ? newSpreadMedia.pages[0]?.groups.media : page.groups.media;
      page.groups.media = sourceMedia?.map((media) => {
        return {
          ...media,
          uuid: elementUuids.generate(),
        };
      });
    });
  }
  designData.spreads.splice(positionAtIndex, 0, newSpread);
  updateDesignPagesUtil(designData, newSpread.pages.length);
}

export default copySpreadUtil;
